function getTouches(e, mode)
{

  if (typeof mode === "undefined") {
    mode = "normal";
  }
  var touches = [];


  if (mode == "normal") {
    for (k in e.touches) {
      if (e.touches.hasOwnProperty(k)) {
        if (k == "length") {
          continue;
        }
        touches.push({pageX: e.touches[k].pageX, pageY: e.touches[k].pageY, identifier: e.touches[k].identifier});
      }
    }
  }
  else {
    if (typeof e.changedTouches !== "undefined") {

      for (k in e.changedTouches) {
        if (e.changedTouches.hasOwnProperty(k)) {
          if (k == "length") {
            continue;
          }
          touches.push(e.changedTouches[k].identifier);
        }
      }
    }
  }

  return touches;
}
